// extracted by mini-css-extract-plugin
module.exports = {"link":"_94259c17"};